export default __webpack_public_path__ + "static/media/icon-play-blue.0da86e7e.svg";